import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import styles from './Label.module.css';
import type { LabelProps } from './Label.types';
const Label = t0 => {
  const $ = _c(13);
  const {
    children,
    disabled: t1,
    id,
    required: t2,
    variant: t3,
    isControl: t4
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const required = t2 === undefined ? false : t2;
  const variant = t3 === undefined ? "small" : t3;
  const isControl = t4 === undefined ? false : t4;
  const t5 = variant === "large";
  const t6 = variant === "small";
  let t7;
  if ($[0] !== disabled || $[1] !== isControl || $[2] !== t5 || $[3] !== t6) {
    t7 = clsx(styles.label, {
      [styles.disabled]: disabled,
      [styles.large]: t5,
      [styles.small]: t6,
      [styles.control]: isControl
    });
    $[0] = disabled;
    $[1] = isControl;
    $[2] = t5;
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const className = t7;
  const t8 = `label-${id}`;
  let t9;
  if ($[5] !== required) {
    t9 = required && <span className={styles.required} aria-hidden="true">*</span>;
    $[5] = required;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== children || $[8] !== className || $[9] !== id || $[10] !== t8 || $[11] !== t9) {
    t10 = <label className={className} htmlFor={id} data-test-id={t8}>{children}{" "}{t9}</label>;
    $[7] = children;
    $[8] = className;
    $[9] = id;
    $[10] = t8;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  return t10;
};
export { Label };